// The session check App.js runs once on load, as a function that always resolves.
//
// ProtectedRoute shows "Verificando sesión..." until App.js marks this check settled, so the
// check must settle whatever the server does. `verifyBusinessToken` throws when the server
// cannot answer — down, mid-deploy, offline, or a body that is not JSON — and before this
// every private route then waited for good.
//
// "unreachable" is kept apart from "invalid" on purpose: a server that did not answer says
// nothing about the session, so the caller should not clear it the way it does for a session
// the server rejected.

export async function checkSession({ hasSessionCookie, verify }) {
  if (!hasSessionCookie) return { status: "none" };

  try {
    const session = await verify();
    return session?.success ? { status: "valid", session } : { status: "invalid" };
  } catch (error) {
    return { status: "unreachable", error };
  }
}
